export default "__VITE_ASSET__Og5HWxPC__"